import { render, staticRenderFns } from "./BankAccountsModal.vue?vue&type=template&id=e5935bbe&"
import script from "./BankAccountsModal.vue?vue&type=script&lang=js&"
export * from "./BankAccountsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports